module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started.1d8bbac4.png";